import type { ValueFieldSize } from './types'

/**
 * Спека 02 §A2: 60px у главного поля и 54px у второстепенных. Под 54 токена нет
 * ($control-height-m=50, $control-height-xl=60) — то же документированное отклонение,
 * что и у TEXT_INPUT_HEIGHT в shared/ui/TextInput/config.ts.
 */
export const VALUE_FIELD_HEIGHT: Record<ValueFieldSize, string> = {
  M: '54px',
  L: 'var(--control-height-xl)',
}

export const VALUE_FIELD_ICON_SIZE: Record<ValueFieldSize, number> = {
  M: 18,
  L: 20,
}
